import React from 'react';

import { Link } from "react-router-dom";
import { useEffect, useState } from 'react';


const Notification = (props: any) => {

  const [button, setButton] = useState<any>(null);

  const [showElement, setShowElement] = useState(true);

  const [hiding, setHiding] = useState('');

  useEffect(()=>{

    setHiding('');

    if( props.link && props.linkText ){ setButton(<Link className="btn rounded-pill btn-primary" to={props.link} >{props.linkText}</Link>)}

    setTimeout(() => {
      setHiding('d-none');
    }, 8000);

  }, [props])

  return (

      <div className={"container card border-0 custom-shadow my-5 custom-radius alert-fixed "+hiding}>
        <div className="card-body d-flex justify-content-between">
          <div className="d-flex align-items-center">
            {props.text}
          </div>
          <div>
            {button}
          </div>
        </div>
      </div>

  );
}

export default Notification;
